export function openMapApp(lat: number, lng: number): void {
  const coords = `${lat},${lng}`;

  if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
    // Apple Maps – pin at coordinates without label
    window.location.href = `https://maps.apple.com/?ll=${coords}`;
  } else {
    // Google Maps – pin at coordinates without label
    window.location.href = `https://www.google.com/maps/search/?api=1&query=${coords}`;
  }
}
